//控制传入数值的小数点位置和有效位数
function formatFloat(src,pos){
  return Math.round(src * Math.pow(10, pos))/Math.pow(10, pos);
}

//时间格式化
function formatDate(date, year_add = 0) {
  const year = date.getFullYear() + year_add;
  const month = date.getMonth() + 1
  const day = date.getDate()
  return [year, month, day].map(formatNumber).join('-')
}
function formatNumber(n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}

// 求两个数组的差集
function arrayDifference(arr1,arr2){
  var set1 = new Set(arr1);
  var set2 = new Set(arr2);

  var subset = [];

  for (let item of set1) {
    if (!set2.has(item)) {
      subset.push(item);
    }
  }

  return subset;
}

// 去除对象里面属性值的前后空格
function objValTrim(obj){
  for(let i in obj){
    if(typeof(obj[i]) == 'string'){
      obj[i] = obj[i].trim().replace(/[\t]/g, ",")
    }
  }
  return obj;
}



// 深复制数组或对象
function deepCopy(obj) {
  // 只拷贝对象（数组）
  if (typeof obj !== 'object') return;

  // 根据obj的类型判断是新建一个数组还是一个对象
  var newObj = obj instanceof Array ? [] : {};
  for (var key in obj) {
    // 遍历obj,并且判断是obj的属性才拷贝
    if (obj.hasOwnProperty(key)) {
      // 判断属性值的类型，如果是对象递归调用深拷贝
      if(typeof obj[key] === 'object' && (obj[key] != null || obj[key] != undefined)){
        newObj[key] = deepCopy(obj[key]);
      }else{
        newObj[key] = obj[key];
      }

    }
  }
  return newObj;
}

// 把数组中对象的某些字符串转为数值类型(originArr: 需要做处理的数组，stringArr: 需要处理的字符串组成的数组)
function stringToNumber(originArr,stringArr){
  for(let i in originArr){
    for(let j in stringArr){
      // 判断该字段的值能不能转成数值类型（）
      if(!isNaN(parseFloat(originArr[i][stringArr[j]]))){
        originArr[i][stringArr[j]] = parseFloat(originArr[i][stringArr[j]]);
      }
    }
  }
  return originArr;
}

export {
  formatFloat,formatDate,formatNumber,arrayDifference,objValTrim,deepCopy,stringToNumber
};



// WEBPACK FOOTER //
// ./src/common/js/format.js